//usei o ouvidoria como base

import { apiSlice } from '../../../../app/apiSlice';
import configSiteUrls from '../../configs/configSiteUrls';
import { Ouvidoria, OuvidoriaDTO, OuvidoriaHistoricoAddDTO, OuvidoriaHistoricoList, OuvidoriaList, OuvidoriaLogin, OuvidoriaLoginResponse, OuvidoriaRespostaDTO } from './types/Ouvidoria';

const endpointPublicUrl = configSiteUrls.SITE_OUVIDORIA_PUBLIC_EP;
const endpointtUrl = configSiteUrls.SITE_OUVIDORIA_EP;


function addOuvidoria(obj: OuvidoriaDTO) {
  return {
    url: `${endpointPublicUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function addOuvidoriaResposta(obj: OuvidoriaRespostaDTO) {
  return {
    url: `${endpointtUrl}/create`,
    method: 'POST',
    body: obj
  };
}
function addOuvidoriaHistorico(obj: OuvidoriaHistoricoAddDTO) {
  return {
    url: `${endpointtUrl}/historico/create`,
    method: 'POST',
    body: obj
  };
}

function getOuvidoriaByLogin(body: OuvidoriaLogin) {
  if (!body.login || !body.senha) {
    return {
      url: '',      // URL vazia
      method: 'GET' // método inofensivo
    };
  }
  return {
    url: `${endpointPublicUrl}/login`,
    method: 'POST',
    body: body
  };
}









function getOuvidorias({ search }: { search: string }) {
  return {
    url: `${endpointtUrl}/filter?search=${search}`,
    method: 'GET'
  };
}
function getOuvidoriasHistoricos( id: string ) {
  return {
    url: `${endpointtUrl}/historicos/${id}`,
    method: 'GET'
  };
}


function deleteOuvidoria({ id }: { id: string }) {
  return {
    url: `${endpointtUrl}/${id}`,
    method: 'DELETE'
  };
}
function getOuvidoria(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointtUrl}/${id}`,
    method: 'GET'
  };
}



export const ouvidoriaApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getOuvidorias: query<OuvidoriaList[], { search: string }>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getOuvidorias,
      providesTags: ['Ouvidoria']
    }),
     getOuvidoriasHistoricos: query<OuvidoriaHistoricoList[],string>({      
      query: getOuvidoriasHistoricos,
      providesTags: ['Ouvidoria']
    }),

    getOuvidoria: query<Ouvidoria, string>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getOuvidoria,
      providesTags: ['Ouvidoria']
    }),
    getOuvidoriaByLogin: mutation<Ouvidoria, OuvidoriaLogin>({
      query: getOuvidoriaByLogin,
      invalidatesTags: ['Ouvidoria']

    }),

    addOuvidoria: mutation<OuvidoriaLoginResponse, OuvidoriaDTO>({
      query: addOuvidoria,
      invalidatesTags: ['Ouvidoria']
    }),
    addOuvidoriaResposta: mutation<OuvidoriaLoginResponse, OuvidoriaRespostaDTO>({
      query: addOuvidoriaResposta,
      invalidatesTags: ['Ouvidoria']
    }),
     addOuvidoriaHistorico: mutation<OuvidoriaLoginResponse, OuvidoriaHistoricoAddDTO>({
      query: addOuvidoriaHistorico,
      invalidatesTags: ['Ouvidoria']
    }),
    deleteOuvidoria: mutation<void, { id: string }>({
      query: deleteOuvidoria,
      invalidatesTags: ['Ouvidoria']
    })
  })
});
export const { useGetOuvidoriasQuery, useGetOuvidoriaQuery, useAddOuvidoriaMutation, useDeleteOuvidoriaMutation,useGetOuvidoriaByLoginMutation, useAddOuvidoriaRespostaMutation, useGetOuvidoriasHistoricosQuery } = ouvidoriaApiSlice;
